import Immutable from 'immutable'
import { CUSTOMER_PROFILE } from '../actions/customerProfile'

const defaultState = Immutable.fromJS({
  status: 'UNINIT',
  data: {}
})

export default (state = defaultState, action) => {
  switch (action.type) {
    case `${CUSTOMER_PROFILE}_REQUEST`:
    {
      return state.withMutations((st) => {
        st.set('status', 'PENDING')
        st.set('data', {})
      })
    }

    case `${CUSTOMER_PROFILE}_SUCCESS`:
    {
      return state.withMutations((st) => {
        st.set('status', 'SUCCESS')
        st.set('data', action.res)
      })
    }

    case `${CUSTOMER_PROFILE}_FAILURE`:
    {
      return state.withMutations((st) => {
        st.set('status', 'FAILURE')
        st.set('data', {})
      })
    }

    default:
      return state
  }
}

// Selectors
export const getProfileSelector = ({ profile }) => ({
  profile
})
